import { Routes } from '@angular/router';
import { PanelComponent } from './panels/panel/panel.component';
import { panelRoutes } from './panels/panel/panel.routes';
import { MasterPanelComponent } from './panels/master/master-panel.component';
import { masterPanelRoutes } from './panels/master/master-panel.routes';
import { LoginComponent } from './pages/auth/login/login.component';
import { MicrosoftCallbackComponent } from './pages/auth/microsoft-callback/microsoft-callback.component';

export const routes: Routes = [
  { path: 'auth/sso/callback', component: MicrosoftCallbackComponent },
  { path: 'panel-master', component: MasterPanelComponent, children: masterPanelRoutes },
  { path: 'panel', component: PanelComponent, children: panelRoutes },
  { path: 'auth', loadChildren: () => import('src/app/pages/auth/auth.routes').then(e => e.AUTH_ROUTES)},
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },
];
